// This icon file is generated automatically.
var OperateLogOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M100 173.41c-39.93 0-73.21-33.27-73.21-73.2 0-4 2.66-6.66 6.65-6.66 4 0 6.66 2.66 6.66 6.65a59.65 59.65 0 0059.9 59.9 59.65 59.65 0 0059.9-59.9A59.65 59.65 0 00100 40.3v6.66L73.38 33.65 100 20.34v6.65c39.93 0 73.21 33.28 73.21 73.21 0 39.93-33.28 73.21-73.21 73.21zm-25-67.16c0-3.75 2.5-6.25 6.25-6.25H100V81.25c0-3.75 2.5-6.25 6.25-6.25s6.25 2.5 6.25 6.25v25c0 3.75-2.5 6.25-6.25 6.25h-25c-3.75 0-6.25-2.5-6.25-6.25z" } }] }, "name": "operate-log", "theme": "outlined" };
export default OperateLogOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/OperateLogOutlined.js
// module id = 3189
// module chunks = 0